import Button, { ButtonVariant } from "../../components/ui/Button";

// 레거시 래퍼: 새 코드는 components/ui 의 Button 을 직접 사용한다.
interface SmallButtonProps {
  title: string;
  variant: "normal" | "disable" | "simple" | "secondary";
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const variantMap: Record<SmallButtonProps["variant"], ButtonVariant> = {
  normal: "primary",
  disable: "primary",
  simple: "outline",
  secondary: "outline",
};

export default function SmallButton(props: SmallButtonProps) {
  return (
    <Button
      size="sm"
      variant={variantMap[props.variant]}
      disabled={props.variant === "disable"}
      onClick={(e) =>
        props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>)
      }
    >
      {props.title}
    </Button>
  );
}
